import { connectHook } from 'app/common/components/connect-hook';
import { StringWidget } from './string-widget';
import { useStringWidget } from './string-widget-hook';

export default connectHook(StringWidget, useStringWidget);
